/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_11_P2Inputs */

const en_terms_section_11_p2 = /** @type {(inputs: Terms_Section_11_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuing to use the website after a change means you accept the revised terms. It is worth looking back here from time to time.`)
};

const lv_terms_section_11_p2 = /** @type {(inputs: Terms_Section_11_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turpinot lietot tīmekļvietni pēc izmaiņām, Jūs piekrītat labotajiem noteikumiem. Ik pa laikam ir vērts šeit ieskatīties.`)
};

/**
* | output |
* | --- |
* | "Continuing to use the website after a change means you accept the revised terms. It is worth looking back here from time to time." |
*
* @param {Terms_Section_11_P2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_11_p2 = /** @type {((inputs?: Terms_Section_11_P2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_11_P2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_11_p2(inputs)
	return en_terms_section_11_p2(inputs)
});